import React, { useState, useEffect, useRef } from "react";
import {useSelector, useDispatch} from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from 'notistack';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import NavPills from "components/NavPills/NavPills.js";
import RequestTable from "views/Widgets/ClinicalRequests/RequestTable";
import ModalEditScheduleTime from "components/ClinicalRequests/ModalEditScheduleTime";
import ModalEnableAddress from "components/ClinicalRequests/ModalEnableAddress";
import ModalEnableAddressWarehouse from "components/ClinicalRequests/ModalEnableAddressWarehouse";
import ModalTranscriptionTelemedicina from "components/ClinicalRequests/ModalTranscriptionTelemedicina";
import ModalDecompensation from "components/PatientFile/ModalDecompensation";
import ModalRoute from "components/ClinicalRequests/ModalRoute";
import ModalReplaceMedicine from "components/ClinicalRequests/ModalReplaceMedicine";
import ModalCheckEquipment from "components/ClinicalRequests/ModalCheckEquipment";
import ModalCheckEquipStatus from "components/ClinicalRequests/ModalCheckEquipStatus";
import ModalauthorizationQuotation from "components/ClinicalRequests/ModalauthorizationQuotation";
import ModalUploadDocumentAntibiotic from "components/ClinicalRequests/ModalUploadDocumentAntibiotic";
import ModalManagerRequestAntibiotic from "components/ClinicalRequests/ModalManagerRequestAntibiotic";
import ModalRequestTelemedicina from "components/PatientFile/ModalRequestTelemedicina";
import ModalDetailResourcesDriver from "components/ClinicalRequests/ModalDetailResourcesDriver";
import ModalProgressExtra from "components/ClinicalRequests/ModalProgressExtra"
import ModalDocumentoFaltante from "components/ClinicalRequests/ModalDocumentoFaltante"
import ModalAprobacionGescaec from "components/ClinicalRequests/ModalAprobacionGescaec"
import ModalUploadAutorizationPending from "components/ClinicalRequests/ModalUploadAutorizationPending"
import ModalTabletLose from "components/ClinicalRequests/ModalTabletLose";
import ModalAlertStock from "components/ClinicalRequests/ModalAlertStock";
import ModalAssingAdvice from "components/ClinicalRequests/ModalAssingAdvice";
import SelectedRequest from "./SelectedRequest";
import SelectedContract from "./SelectedContract";
import ModalExamData from "views/PatientFile/Examenes/Details/ModalExamData";
import ModalUploadAuthorization from "views/PatientFile/Examenes/Details/ModalUploadAuthorization";
import ModalUploadExamRequest from "views/PatientFile/Examenes/Details/ModalUploadExamRequest";
import ModalPreviewRequestEquipment from "views/PatientFile/Equipos/ModalPreviewRequestEquipment";
import ModalExamWaiting from "views/PatientFile/Examenes/Details/ModalExamWaiting";
import ModalExamToPerform from "views/PatientFile/Examenes/Details/ModalExamToPerform";
import ModalEditRequestInProcess from "views/PatientFile/InsumosYMedicamentos/ModalEditRequestInProces";
import ModalAddAuthorization from "./AddAuthorization/ModalAddAuthorization";
import ModalAddAuthorizationPersonal from "./AddAuthorization/ModalAddAuthorizationPersonal";
import ModalEditPersonal from "./AddAuthorization/ModalEditPersonal";
import ModalEndVisit from "components/PatientFile/ModalEndVisit";

import {
  Breadcrumbs,
  Link,
  Typography,
} from "@material-ui/core";
import {
    Event,
} from '@material-ui/icons';
import moment from "moment-timezone";
import api from "utils/API";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import {
    getListSuppliesMedicines,
} from 'actions/getListAction';
import "moment/locale/es";
moment.locale("es");

const DEFAULT_TAB_QUERY = { page: 0, pageSize: 25, orderBy: null, orderType: null, columnFilters: [] };
const TAB_QUERY_DEBOUNCE_MS = 1000;

// Indices de las pestañas de NavPills en ClinicalRequest, en el mismo orden
// que el array `tabs` pasado a NavPills mas abajo.
const TAB_PROCESO = 0;
const TAB_ESPERA = 1;
const TAB_FINALIZADO = 2;

// Columnas de RequestTable.js que el backend puede ordenar (campos directos del
// modelo). El resto de las columnas ignora el click de orden.
const ORDER_FIELD_BY_COLUMN = {
    0: "id_solicitud_paciente_id",
    1: "id",
    5: "fecha_hora",
};

// Traduce los filtros por columna de RequestTable.js (mismo orden que su
// headerTable) a los query params que soporta /tareaspaciente/logeado/.
const buildColumnFilterParams = (columnFilters) => {
    const [
        idSolicitud, idTarea, tipoTarea, solicitanteFecha,
        paciente, fechaInicioTermino, estado,
    ] = columnFilters || [];
    const params = {};
    if (idSolicitud) params.id_solicitud = idSolicitud;
    if (idTarea) params.id_tarea = idTarea;
    if (tipoTarea) params.tipo_tarea = tipoTarea;
    if (solicitanteFecha) {
        // Columna combinada "Solicitado por": el filtro por texto se aplica
        // contra el nombre del solicitante, el campo primario mostrado.
        params.solicitante = solicitanteFecha;
    }
    if (paciente) params.paciente = paciente;
    if (fechaInicioTermino) {
        // Columna combinada "Fecha inicio/término": el filtro por texto se
        // aplica contra la fecha de inicio (fecha_hora), que es el campo
        // primario mostrado y el que ya se usa como orden por defecto.
        params.fecha_inicio_desde = fechaInicioTermino;
        params.fecha_inicio_hasta = fechaInicioTermino;
    }
    if (estado) params.estado = estado;
    return params;
};

const fetchTareasTab = (endpointSuffix, groupParam, query, setData) => {
    const params = new URLSearchParams();
    params.set("page", String(query.page + 1));
    params.set("page_size", String(query.pageSize));
    if (groupParam) params.set("grupo", groupParam);
    const orderField = query.orderBy !== null ? ORDER_FIELD_BY_COLUMN[query.orderBy] : null;
    if (orderField) params.set("ordering", `${query.orderType === "desc" ? "-" : ""}${orderField}`);
    Object.entries(buildColumnFilterParams(query.columnFilters)).forEach(([key, value]) => params.set(key, value));
    return api.get(`/api/clinica/tareaspaciente/logeado/${endpointSuffix}?${params.toString()}`)
        .then((response) => setData({ results: response.data.results, count: response.data.count }));
};

const useStyles = makeStyles(styles);

const ClinicalRequest = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [userData, setuserData] = useState("");
    const [activeTab, setActiveTab] = useState(TAB_PROCESO);
    const [queryProceso, setQueryProceso] = useState({ ...DEFAULT_TAB_QUERY });
    const [queryEspera, setQueryEspera] = useState({ ...DEFAULT_TAB_QUERY });
    const [queryFinalizado, setQueryFinalizado] = useState({ ...DEFAULT_TAB_QUERY });
    const [dataProceso, setDataProceso] = useState({ results: [], count: 0 });
    const [dataEspera, setDataEspera] = useState({ results: [], count: 0 });
    const [dataFinalizado, setDataFinalizado] = useState({ results: [], count: 0 });
    const [routeTasks, setRouteTasks] = useState([]);
    const [selectRowDetails, setselectRowDetails] = useState(null);
    const [editRowDetails, seteditRowDetails] = useState(null);
    const [openModalRoute, setopenModalRoute] = useState(false);
    const [selectEnableAddress, setselectEnableAddress] = useState(null);
    const [selectEnableAddressContracts, setselectEnableAddressContracts] = useState(null);
    const [selectEnableAddressWarehouse, setselectEnableAddressWarehouse] = useState(null);
    const [selectDecompetation, setselectDecompetation] = useState(null);
    const [selectRewriteTelemedicina, setselectRewriteTelemedicina] = useState(null);
    const [selectTelemedicinaModal, setselectTelemedicinaModal] = useState(null);
    const [selectTransportItem, setselectTransportItem] = useState(null);
    const [selectProgressExtra, setselectProgressExtra] = useState(null);
    const [uploadAutorizationPending, setuploadAutorizationPending] = useState(null);
    const [selectDocumentoFaltante, setselectDocumentoFaltante] = useState(null);
    const [selectAprobacionGescaec, setselectAprobacionGescaec] = useState(null);
    const [selectResumenSolicitud, setselectResumenSolicitud] = useState(null);
    const [selectPatient, setselectPatient] = useState(null);
    const [selectFile, setselectFile] = useState(null);
    const [listProfDecompensation, setlistProfDecompensation] = useState([]);
    const [listassigned, setlistassigned] = useState([]);
    const [tensAssigned, settensAssigned] = useState([]);
    const listPeriod =[
        {value: "Horario", label: "Horario"},
        {value: "Diario", label: "Diario"},
        {value: "Semanal", label: "Semanal"},
        {value: "Mensual", label: "Mensual"},
        {value: "Anual", label: "Anual"},
    ];

    const [openModalExam, setOpenModalExam] = useState(false);
    const [openModalUploadAuthorization, setOpenModalUploadAuthorization] = useState(false);
    const [openModalWaitingContract, setOpenModalWaitingContract] = useState(false);
    const [openModalToPerform, setOpenModalToPerform] = useState(false);
    const [tempRow, setTempRow] = useState(null);
    const [openModalRequestExam, setOpenModalRequestExam] = useState(false);
    const [openModalInsumos, setOpenModalInsumos] = useState(false);
    const [openModalAddAuthorization, setOpenModalAddAuthorization] = useState(false);
    const [openModalAddAuthorizationQuotation, setopenModalAddAuthorizationQuotation] = useState(false);
    const [openModalUploadAuthorizationAntibiotic, setOpenModalUploadAuthorizationAntibiotic] = useState(false);
    const [openModalUploadOrderAntibiotic, setOpenModalUploadOrderAntibiotic] = useState(false);
    const [openModalUploadOrderPersonalClinico, setOpenModalUploadOrderPersonalClinico] = useState(false);
    const [openModalRequestAntibiotic, setOpenModalRequestAntibiotic] = useState(false);
    const [openModalPreviewRequestEquipment, setOpenModalPreviewRequestEquipment] = useState(false);
    const [openModalReplaceMedicine, setopenModalReplaceMedicine] = useState(false);
    const [openModalCheckEquipment, setOpenModalCheckEquipment] = useState(false);
    const [openModalAddAuthorizationProfExtra, setopenModalAddAuthorizationProfExtra] = useState(false);
    const [openModalEditProfExtra, setopenModalEditProfExtra] = useState(false);
    const [openModalTabletLose, setopenModalTabletLose] = useState(null);
    const [openModalAlertStock, setopenModalAlertStock] = useState(null);
    const [openModalAsssingWorks, setopenModalAsssingWorks] = useState(null);
    const [infoReplaceMedicine, setinfoReplaceMedicine] = useState(null)
    const [infoCheckEquipment, setInfoCheckEquipment] = useState(null)
    const [openRouteWorks, setopenRouteWorks] = useState(null);
    const [openCheckEquip, setopenCheckEquip] = useState(null);
    const [infoRow,  setInfoRow] = useState(null)
    const [tipoTarea, setTipoTarea] = React.useState("");
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const listMedical = useSelector(state => state.currentList.listMedicinesNoNull);
    const listResource = useSelector(state => state.currentList.listSuppliesNoNull);
    const medicalResourceData = useSelector(state => state.currentList.dictSuppliesMedicines);
    const chargeMedicine = useSelector(state => state.currentGlobalVar.chargeMedicine);

    const dictStateWork = useSelector(state => state.currentList.DICCIONARIO_ESTADO_TAREAS_FICHA);

    useEffect(() => {
        if(listMedical.length === 0) {
            getListSuppliesMedicines(dispatch, chargeMedicine)
        }
    }, []);

    const action = key => (
        <Button style={{background: "#af4c4c00",  color: "#fff"}} onClick={() => {closeSnackbar(key)}}>
            CERRAR
        </Button>
    );

    const handleSnakeMessage = (message, variant, vertical= "top", hotizontal="center", persist=false) => {
        enqueueSnackbar(
            message,
            {
                variant,
                persist: persist,
                action,
                preventDuplicate: true,
                anchorOrigin: {
                    vertical: vertical,
                    horizontal: hotizontal,
                },
            }
        );
    };

    useEffect(() => {
        api.get(`/api/usuario/${window.localStorage.getItem("user_id")}`).then((response) => {
            setuserData(response.data);
        });
    }, []);

    // Al entrar a la pagina o cambiar de pestaña: fetch inmediato de la
    // pestaña que se acaba de activar, sin debounce. Solo depende de
    // activeTab, no de la query, para no mezclarse con la busqueda.
    useEffect(() => {
        if (activeTab === TAB_PROCESO) fetchTareasTab("", "proceso", queryProceso, setDataProceso);
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === TAB_ESPERA) fetchTareasTab("", "espera", queryEspera, setDataEspera);
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === TAB_FINALIZADO) fetchTareasTab("finalizado/", null, queryFinalizado, setDataFinalizado);
    }, [activeTab]);

    // Paginacion/orden/filtro dentro de una pestaña ya activa: page, pageSize,
    // orderBy/orderType disparan el fetch de inmediato (misma logica que el
    // cambio de pestaña de arriba); solo los filtros de texto por columna
    // pasan por un debounce (ver buildTabTableProps), para no generar un
    // request por cada tecla escrita. Un timer de debounce por pestaña evita
    // que un filtro tipeado rapido en una pestaña dispare varios requests.
    const filterDebounceTimerProceso = useRef(null);
    const filterDebounceTimerEspera = useRef(null);
    const filterDebounceTimerFinalizado = useRef(null);

    // "Generar ruta" necesita ver el listado completo de tareas activas del usuario
    // (no la pagina actual de la tabla), asi que pide su propio fetch al abrirse.
    useEffect(() => {
        if (openModalRoute) {
            api.get(`/api/clinica/tareaspaciente/logeado/`).then((response) => {
                setRouteTasks(response.data);
            });
        }
    }, [openModalRoute]);

    // Recarga solo el endpoint de la pestaña que el usuario tiene abierta.
    // Las otras pestañas se refrescan solas al abrirlas (ver los useEffect
    // de arriba, gateados por activeTab).
    const refetchActiveTabs = () => {
        if (activeTab === TAB_PROCESO) fetchTareasTab("", "proceso", queryProceso, setDataProceso);
        else if (activeTab === TAB_ESPERA) fetchTareasTab("", "espera", queryEspera, setDataEspera);
        else if (activeTab === TAB_FINALIZADO) fetchTareasTab("finalizado/", null, queryFinalizado, setDataFinalizado);
    };

    // endpointSuffix/groupParam/setData identifican la pestaña para poder
    // disparar su fetch directamente desde cada callback: page/rowsPerPage/
    // orden se piden de inmediato (el usuario ya tomo una decision completa
    // con ese click); los filtros de texto usan filterDebounceTimerRef para
    // esperar una pausa en la escritura antes de pedir al backend.
    const buildTabTableProps = (query, setQuery, data, endpointSuffix, groupParam, setData, filterDebounceTimerRef) => {
        const fetchNow = (nextQuery) => fetchTareasTab(endpointSuffix, groupParam, nextQuery, setData);
        const applyImmediate = (nextQuery) => {
            setQuery(nextQuery);
            fetchNow(nextQuery);
        };

        return {
            dataArray: data.results,
            totalCount: data.count,
            page: query.page,
            rowsPerPage: query.pageSize,
            onChangePage: (newPage) => applyImmediate({ ...query, page: newPage }),
            onChangeRowsPerPage: (newSize) => applyImmediate({ ...query, pageSize: newSize, page: 0 }),
            orderBy: query.orderBy,
            orderType: query.orderType,
            onOrderChange: (index, newType) => {
                if (!(index in ORDER_FIELD_BY_COLUMN)) return;
                applyImmediate({ ...query, orderBy: index, orderType: newType, page: 0 });
            },
            columnFilters: query.columnFilters,
            onColumnFilterChange: (value, index) => {
                const nextFilters = [...query.columnFilters];
                nextFilters[index] = value;
                const nextQuery = { ...query, columnFilters: nextFilters, page: 0 };
                setQuery(nextQuery);
                clearTimeout(filterDebounceTimerRef.current);
                filterDebounceTimerRef.current = setTimeout(() => fetchNow(nextQuery), TAB_QUERY_DEBOUNCE_MS);
            },
        };
    };

    const handleClickDetails = (row, index) => {
        if (row.estado === "EsperandoConfirmacion"){
            seteditRowDetails([row, index]);
        } else if (row.estado === "Incompleto") {
            setselectRowDetails([row, index]);
        }
    };

    const handleEnableAddress = (row) => {
        api.get(
            `/api/clinica/solicitudes/pacientes/${row.id_ficha.id_paciente.id}/coordinador/prestaciones/`
        ).then((response) => {
            setselectEnableAddress({
                row: row,
                benefits: response.data,
            })
        });
    };

    const handleUpdateRowState = (row, state) => {
        const stateArray = ["Incompleto", "PorRealizar", "GestionarContratos", "SubirContratos"]
        const message = stateArray.includes(state)
            ? `Estado de la tarea actualizado a: "${dictStateWork[state]?.label}"`
            : "Tarea finalizada";
        handleSnakeMessage(message, "success");
        refetchActiveTabs();
    };

    const handleUpdateState = (argRequest) => {
        const message = argRequest.estado === "Agendada"
            ? "Tarea Agendada"
            : `Estado de la tarea actualizado a: "${dictStateWork[argRequest.estado]?.label}"`;
        handleSnakeMessage(message, "success");
        setselectRowDetails(null);
        refetchActiveTabs();
    };

    const handleClearState = () => {
        refetchActiveTabs();
    }

    const handleDecompetation = (selectRow) => {
        setselectPatient(selectRow.id_ficha.id_paciente);
        setselectFile(selectRow.id_ficha);
        const requestChargesWorks = api.get("api/paciente/cargos/tareas/");
        const requestProfesionalDecompensation = api.get("api/paciente/descompensacion/obtener/profesionales/");
        Promise.all([
            requestChargesWorks,
            requestProfesionalDecompensation
        ]).then((request) => {
            const auxChargesTemp =  request[0].data;
            setlistassigned([
                {
                    label: 'Enfermeria',
                    options: auxChargesTemp["nursingList"],
                },
            ]);
            setlistProfDecompensation(request[1].data);
        });


        api.get(`api/paciente/${selectRow.id_ficha.id_paciente.id}/solicitudes/descompensacion/${selectRow.id_solicitud_paciente.id}/`).then((response) => {
            setselectDecompetation([response.data, selectRow]);

        });
    };

    const handleRewriteTelemedicina = (selectRow) => {
        setselectPatient(selectRow.id_ficha.id_paciente);
        setselectFile(selectRow.id_ficha);
        const requestChargesWorks = api.get("api/paciente/cargos/tareas/");
        const requestTenstPatient = api.get(`api/clinica/pacientes/${selectRow.id_ficha.id_paciente.id}/tens/`);
        Promise.all([
            requestChargesWorks,
            requestTenstPatient
        ]).then((request) => {
            const auxChargesTemp =  request[1].data;
            const tempTensassigned =  request[0].data.map((task) => {
                const tempTask = {...task};
                tempTask.fecha_hora = moment(task.fecha_hora)
                    .format("YYYY-MM-DD hh:mm:ss")
                    .toString();
                if (task.fecha_final == task.fecha_hora){
                    tempTask.fecha_final = moment(task.fecha_final).add(1, "day");
                }
                tempTask.fecha_final = moment(tempTask.fecha_final)
                    .format("YYYY-MM-DD hh:mm:ss")
                    .toString();
                return tempTask
            });
            settensAssigned(tempTensassigned);
            setlistassigned([
                {
                    label: 'Enfermeria',
                    options: auxChargesTemp["nursingList"],
                },
            ]);
            setselectRewriteTelemedicina(selectRow);
        });
    };

    const handleUpdateStateDecompetation = () => {
        refetchActiveTabs();
    };


    const handleInsumos = row => {
        let tempRow = {
            ...row,
            id_paciente: row.id_ficha.id_paciente.id,
            id_row: row.id
        }
        tempRow["id"] = row.id_solicitud_paciente.id;
        setTempRow(tempRow);
        setOpenModalInsumos(true);
    };

    const handleReplacementMedicine  = (row) => {

        const requestWork = api.get(`api/bodega/reemplazo/producto/tarea/${row.id}/info/`);
        Promise.all([requestWork]).then((request) => {
            const auxRecplacementData = request[0].data;
            if (auxRecplacementData["message"]){
                handleSnakeMessage("Tarea finalizada", "success");
                window.location.reload();
            }
            auxRecplacementData["tarea"] = row;
            setinfoReplaceMedicine(auxRecplacementData);
            setopenModalReplaceMedicine(true);
        });
    };
    const handleCheckEquipment  = (row) => {
        api
            .get(`api/ingresos/solicitud/${row.id_solicitud_ingreso_id}/productos/`)
            .then(request => {
                setInfoCheckEquipment(request.data[0]);
                setInfoRow(row)
                setOpenModalCheckEquipment(true);
            });
    };

    const handleOnClickNav = (tabIndex) => {
        setActiveTab(tabIndex);
    }

    return (
        <GridContainer>
            <GridItem
                container
                direction="row"
                justify="center"
                alignItems="center"
                xs={12}
            >
                <GridItem xs={12}>
                    <CardBody className="rounded shadow border border-primary">
                        {selectRowDetails ?
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                color="inherit"
                                style={{cursor: "pointer"}}
                                onClick={() => setselectRowDetails(null)}
                            >
                                Mis tareas
                            </Link>
                            <Typography color="textPrimary">{`${selectRowDetails[0].id}`}</Typography>
                        </Breadcrumbs> :
                        selectEnableAddressContracts ?
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                color="inherit"
                                style={{cursor: "pointer"}}
                                onClick={() => setselectEnableAddressContracts(null)}
                            >
                                Mis tareas
                            </Link>
                            <Typography color="textPrimary">{`${selectEnableAddressContracts.id}`}</Typography>
                        </Breadcrumbs> :
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                color="inherit"
                                style={{cursor: "pointer"}}
                            >
                                Mis tareas
                            </Link>
                        </Breadcrumbs>
                        }

                    </CardBody>
                </GridItem>
                {selectRowDetails ?
                <SelectedRequest
                    selectRowDetails={selectRowDetails}
                    handleUpdateState={handleUpdateState}
                /> :
                selectEnableAddressContracts ?
                <SelectedContract
                    selectContracts={selectEnableAddressContracts}
                    setselectContracts={setselectEnableAddressContracts}
                    handleUpdateRowState={handleUpdateRowState}
                    setselectRowDetails={setselectRowDetails}
                /> :
                <Card>
                    <CardBody>
                        <GridItem
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                            xs={12}
                        >
                            <GridItem
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                                xs={11}
                            >
                                <Button
                                    style={{ textTransform: "none" }}
                                    color={"info"}
                                    onClick={() => setopenModalRoute(true)}
                                >
                                    Generar ruta
                                </Button>
                            </GridItem>
                            <GridItem
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                                xs={1}
                            >
                                <Button
                                    justIcon
                                    round
                                    color={"info"}
                                    className={classes.marginRight}
                                >
                                    <Event className={classes.icons} />
                                </Button>
                            </GridItem>
                        </GridItem>
                        <NavPills
                            color="primary"
                            alignCenter
                            onClick={handleOnClickNav}
                            tabs={[
                                {
                                    tabButton: "En proceso",
                                    tabContent: (
                                        <RequestTable
                                            {...buildTabTableProps(queryProceso, setQueryProceso, dataProceso, "", "proceso", setDataProceso, filterDebounceTimerProceso)}
                                            handleClickDetails={handleClickDetails}
                                            handleEnableAddress={handleEnableAddress}
                                            handleEnableAddressContracts={setselectEnableAddressContracts}
                                            handleEnableAddressWarehouse={setselectEnableAddressWarehouse}
                                            handleDecompetation={handleDecompetation}
                                            handleRewriteTelemedicina={handleRewriteTelemedicina}
                                            handleRequestTelemedicina={setselectTelemedicinaModal}
                                            handlesTransport={setselectTransportItem}
                                            handleProgressExtra={setselectProgressExtra}
                                            handleUploadAutorizationPending={setuploadAutorizationPending}
                                            handleDocumentoFaltante={setselectDocumentoFaltante}
                                            handleAprobacionGescaec={setselectAprobacionGescaec}
                                            title={"proceso"}
                                            setOpenModalExam={setOpenModalExam}
                                            setOpenModalRequestExam={setOpenModalRequestExam}
                                            setOpenModalUploadAuthorization={setOpenModalUploadAuthorization}
                                            setOpenModalWaitingContract={setOpenModalWaitingContract}
                                            setOpenModalToPerform={setOpenModalToPerform}
                                            setopenModalAddAuthorizationQuotation={setopenModalAddAuthorizationQuotation}
                                            setOpenModalUploadAuthorizationAntibiotic={setOpenModalUploadAuthorizationAntibiotic}
                                            setOpenModalPreviewRequestEquipment={setOpenModalPreviewRequestEquipment}
                                            setTipoTarea={setTipoTarea}
                                            setOpenModalUploadOrderAntibiotic={setOpenModalUploadOrderAntibiotic}
                                            setOpenModalUploadOrderPersonalClinico={setOpenModalUploadOrderPersonalClinico}
                                            setOpenModalRequestAntibiotic={setOpenModalRequestAntibiotic}
                                            handleCheckEquipment={handleCheckEquipment}
                                            setTempRow={setTempRow}
                                            handleInsumos={handleInsumos}
                                            handleReplacementMedicine={handleReplacementMedicine}
                                            setOpenModalAddAuthorization={setOpenModalAddAuthorization}
                                            setopenModalAddAuthorizationProfExtra={setopenModalAddAuthorizationProfExtra}
                                            setopenModalEditProfExtra={setopenModalEditProfExtra}
                                            setopenModalTabletLose={setopenModalTabletLose}
                                            setopenModalAlertStock={setopenModalAlertStock}
                                            setopenModalAsssingWorks={setopenModalAsssingWorks}
                                            setopenRouteWorks={setopenRouteWorks}
                                            setopenCheckEquip={setopenCheckEquip}

                                        />
                                    )
                                },
                                {
                                    tabButton: "Esperando a otra área",
                                    tabContent: (
                                        <RequestTable
                                            {...buildTabTableProps(queryEspera, setQueryEspera, dataEspera, "", "espera", setDataEspera, filterDebounceTimerEspera)}
                                            handleClickDetails={handleClickDetails}
                                            handleEnableAddress={handleEnableAddress}
                                            handleEnableAddressContracts={setselectEnableAddressContracts}
                                            handleEnableAddressWarehouse={setselectEnableAddressWarehouse}
                                            handleDecompetation={handleDecompetation}
                                            handleResumenSolicitud={setselectResumenSolicitud}
                                            title={"otro"}
                                        />
                                    )
                                },
                                {
                                    tabButton: "Finalizadas",
                                    tabContent: (
                                        <RequestTable
                                            {...buildTabTableProps(queryFinalizado, setQueryFinalizado, dataFinalizado, "finalizado/", null, setDataFinalizado, filterDebounceTimerFinalizado)}
                                            handleProgressExtra={setselectProgressExtra}
                                            handleResumenSolicitud={setselectResumenSolicitud}
                                            setopenModalTabletLose={setopenModalTabletLose}
                                            title={"finalizado"}
                                        />

                                    )
                                }
                            ]}
                            />
                    </CardBody>
                    {editRowDetails &&
                    <ModalEditScheduleTime
                        open={!!editRowDetails}
                        handleClose={() => seteditRowDetails(null)}
                        editRowDetails={editRowDetails}
                        handleClearState={handleClearState}
                        setselectRowDetails={setselectRowDetails}
                    />
                    }
                    {openModalRoute &&
                    <ModalRoute
                        open={!!openModalRoute}
                        handleClose={() => setopenModalRoute(null)}
                        requestArray={routeTasks}
                        userData={userData}
                    />
                    }
                    {selectEnableAddress &&
                        <ModalEnableAddress
                            open={!!selectEnableAddress}
                            handleClose={() => setselectEnableAddress(null)}
                            selectEnableAddress={selectEnableAddress}
                        />
                    }
                    {selectEnableAddressWarehouse &&
                        <ModalEnableAddressWarehouse
                            open={!!selectEnableAddressWarehouse}
                            handleClose={() => setselectEnableAddressWarehouse(null)}
                            selectEnableAddress={selectEnableAddressWarehouse}
                            handleUpdateRowState={handleUpdateRowState}
                        />
                    }
                    {selectDecompetation &&
                    <ModalDecompensation
                        open={!!selectDecompetation}
                        handleClose={() => setselectDecompetation(false)}
                        listPeriod={listPeriod}
                        listassigned={listassigned}
                        listProfDecompensation={listProfDecompensation}
                        medicalResourceData={medicalResourceData}
                        switchProps={true}
                        requestDataWork={selectDecompetation}
                        patient={selectPatient}
                        dataFile={selectFile}
                        handleUpdateStateDecompetation={handleUpdateStateDecompetation}
                    />
                    }
                    {selectRewriteTelemedicina &&
                    <ModalTranscriptionTelemedicina
                        open={!!selectRewriteTelemedicina}
                        handleClose={() => setselectRewriteTelemedicina(null)}
                        listMedical={listMedical}
                        listPeriod={listPeriod}
                        listassigned={listassigned}
                        tensAssigned={tensAssigned}
                        requestDataWork={selectRewriteTelemedicina}
                        dataFile={selectFile}
                        dataPatient={selectPatient}
                    />
                    }
                    {openModalUploadAuthorizationAntibiotic &&
                        <ModalUploadDocumentAntibiotic
                            tempRow={tempRow}
                            documentType={"autorizacion"}
                            openModal={openModalUploadAuthorizationAntibiotic}
                            closeModal={() => setOpenModalUploadAuthorizationAntibiotic(false)}
                            setinitialCharge={refetchActiveTabs}
                        />
                    }
                    {openModalPreviewRequestEquipment &&
                        <ModalPreviewRequestEquipment
                            tempRow={tempRow}
                            openModal={openModalPreviewRequestEquipment}
                            closeModal={() => setOpenModalPreviewRequestEquipment(false)}
                            tipoTarea={tipoTarea}
                        />
                    }
                    {openModalUploadOrderAntibiotic &&
                        <ModalUploadDocumentAntibiotic
                            tempRow={tempRow}
                            documentType={"orden"}
                            openModal={openModalUploadOrderAntibiotic}
                            closeModal={() => setOpenModalUploadOrderAntibiotic(false)}
                            setinitialCharge={refetchActiveTabs}
                        />
                    }
                    {openModalUploadOrderPersonalClinico &&
                        <ModalUploadDocumentAntibiotic
                            tempRow={tempRow}
                            documentType={"ordenPersonalClinico"}
                            openModal={openModalUploadOrderPersonalClinico}
                            closeModal={() => setOpenModalUploadOrderPersonalClinico(false)}
                            setinitialCharge={refetchActiveTabs}
                        />
                    }
                    {openModalRequestAntibiotic &&
                        <ModalManagerRequestAntibiotic
                            tempRow={tempRow}
                            openModal={openModalRequestAntibiotic}
                            closeModal={() => setOpenModalRequestAntibiotic(false)}
                            setinitialCharge={refetchActiveTabs}
                        />
                    }

                    {openModalExam && (
                        <ModalExamData
                        tempRow={tempRow}
                        openModal={openModalExam}
                        closeModal={() => setOpenModalExam(false)}
                        loadExams={false}
                        setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {openModalUploadAuthorization && (
                        <ModalUploadAuthorization
                            tempRow={tempRow}
                            openModal={openModalUploadAuthorization}
                            closeModal={() => setOpenModalUploadAuthorization(false)}
                        />
                    )}
                    {openModalRequestExam && (
                        <ModalUploadExamRequest
                        tempRow={tempRow}
                        openModal={openModalRequestExam}
                        closeModal={() => setOpenModalRequestExam(false)}
                        />
                    )}
                    {openModalWaitingContract && (
                        <ModalExamWaiting
                        tempRow={tempRow}
                        openModal={openModalWaitingContract}
                        closeModal={() => setOpenModalWaitingContract(false)}
                        setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {openModalToPerform && (
                        <ModalExamToPerform
                        tempRow={tempRow}
                        openModal={openModalToPerform}
                        closeModal={() => setOpenModalToPerform(false)}
                        setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {openModalInsumos && (
                        <ModalEditRequestInProcess
                        openModal={openModalInsumos}
                        closeModal={() => setOpenModalInsumos(false)}
                        rowInfo={tempRow}
                        listMedical={listMedical}
                        listResource={listResource}
                        medicalResourceData={medicalResourceData}
                        dataArray={dataProceso.results}
                        onActionComplete={refetchActiveTabs}
                        type={"2"}
                        isSpecific={true}
                        />
                    )}
                    {openModalAddAuthorization && (
                        <ModalAddAuthorization
                            openModal={openModalAddAuthorization}
                            closeModal={() => setOpenModalAddAuthorization(false)}
                            tempRow={tempRow}
                            onActionComplete={refetchActiveTabs}
                        />
                    )}
                    {openModalAddAuthorizationProfExtra && (
                        <ModalAddAuthorizationPersonal
                            openModal={!!openModalAddAuthorizationProfExtra}
                            closeModal={() => setopenModalAddAuthorizationProfExtra(false)}
                            tempRow={openModalAddAuthorizationProfExtra}
                            onActionComplete={refetchActiveTabs}
                        />
                    )}
                    {openModalEditProfExtra && (
                        <ModalEditPersonal
                            openModal={!!openModalEditProfExtra}
                            closeModal={() => setopenModalEditProfExtra(false)}
                            tempRow={openModalEditProfExtra}
                            onActionComplete={refetchActiveTabs}
                        />
                    )}
                    {openModalAddAuthorizationQuotation && (
                        <ModalauthorizationQuotation
                            openModal={openModalAddAuthorizationQuotation}
                            closeModal={() => setopenModalAddAuthorizationQuotation(false)}
                            tempRow={tempRow}
                            onActionComplete={refetchActiveTabs}
                        />
                    )}
                    {openModalReplaceMedicine && (
                        <ModalReplaceMedicine
                            open={openModalReplaceMedicine}
                            closeModal={() => setopenModalReplaceMedicine(false)}
                            info={infoReplaceMedicine}
                            listMedical={listMedical}
                            setinitialCharge={refetchActiveTabs}

                        />
                    )}
                    {openModalCheckEquipment && (
                        <ModalCheckEquipment
                            open={openModalCheckEquipment}
                            closeModal={() => setOpenModalCheckEquipment(false)}
                            info={infoCheckEquipment}
                            handleCheckEquipment={handleCheckEquipment}
                            infoRow={infoRow}
                        />
                    )}
                    {selectTelemedicinaModal && (
                        <ModalRequestTelemedicina
                            open={!!selectTelemedicinaModal}
                            closeModal={() => setselectTelemedicinaModal(null)}
                            dataPatient={selectTelemedicinaModal?.id_ficha?.id_paciente || {}}
                            requestInfo={selectTelemedicinaModal?.id_solicitud_paciente || {}}
                        />
                    )}
                    {selectTransportItem && (
                        <ModalDetailResourcesDriver
                            open={!!selectTransportItem}
                            closeModal={() => setselectTransportItem(null)}
                            infoRow={selectTransportItem}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {selectProgressExtra && (
                        <ModalProgressExtra
                            open={selectProgressExtra}
                            closeModal={() => setselectProgressExtra(false)}
                            rowInfo={selectProgressExtra}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}

                    {uploadAutorizationPending && (
                        <ModalUploadAutorizationPending
                            open={uploadAutorizationPending}
                            closeModal={() => setuploadAutorizationPending(false)}
                            rowInfo={uploadAutorizationPending}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {selectDocumentoFaltante && (
                        <ModalDocumentoFaltante
                            open={!!selectDocumentoFaltante}
                            closeModal={() => setselectDocumentoFaltante(null)}
                            rowInfo={selectDocumentoFaltante}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {selectAprobacionGescaec && (
                        <ModalAprobacionGescaec
                            open={!!selectAprobacionGescaec}
                            closeModal={() => setselectAprobacionGescaec(null)}
                            rowInfo={selectAprobacionGescaec}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {selectResumenSolicitud && (
                        <ModalProgressExtra
                            open={!!selectResumenSolicitud}
                            closeModal={() => setselectResumenSolicitud(null)}
                            rowInfo={selectResumenSolicitud}
                            setinitialCharge={refetchActiveTabs}
                            viewOnly={true}
                        />
                    )}
                    {openModalTabletLose && (
                        <ModalTabletLose
                            open={!!openModalTabletLose}
                            closeModal={() => setopenModalTabletLose(null)}
                            rowInfo={openModalTabletLose}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {openModalAlertStock && (
                        <ModalAlertStock
                            open={!!openModalAlertStock}
                            closeModal={() => setopenModalAlertStock(null)}
                            rowInfo={openModalAlertStock}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {openModalAsssingWorks && (
                        <ModalAssingAdvice
                            open={!!openModalAsssingWorks}
                            closeModal={() => setopenModalAsssingWorks(null)}
                            rowInfo={openModalAsssingWorks}
                            setinitialCharge={refetchActiveTabs}
                        />
                    )}
                    {openRouteWorks &&
                        <ModalEndVisit
                            open={!!openRouteWorks}
                            handleClose={() => setopenRouteWorks(null)}
                            row={openRouteWorks}
                            setinitialCharge={refetchActiveTabs}
                        />
                    }
                    {openCheckEquip &&
                        <ModalCheckEquipStatus
                            open={!!openCheckEquip}
                            handleClose={() => setopenCheckEquip(null)}
                            row={openCheckEquip}
                            setinitialCharge={refetchActiveTabs}
                        />
                    }
                </Card>
                }
            </GridItem>
        </GridContainer>
    );
};

export default ClinicalRequest;
